import "./industries.css";
import SEO from "../../SEO";

/* ── SVG Icons ──────────────────────────────────────────────────────────── */
const TruckIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <rect x="1" y="3" width="15" height="13" rx="1" />
    <polygon points="16 8 20 8 23 11 23 16 16 16 16 8" />
    <circle cx="5.5" cy="18.5" r="2.5" />
    <circle cx="18.5" cy="18.5" r="2.5" />
  </svg>
);

const RouteIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <circle cx="6" cy="19" r="3" />
    <path d="M9 19h8.5a3.5 3.5 0 0 0 0-7h-11a3.5 3.5 0 0 1 0-7H15" />
    <circle cx="18" cy="5" r="3" />
  </svg>
);

const BoxIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
    <polyline points="3.27 6.96 12 12.01 20.73 6.96" />
    <line x1="12" y1="22.08" x2="12" y2="12" />
  </svg>
);

const InventoryIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <line x1="8" y1="6" x2="21" y2="6" />
    <line x1="8" y1="12" x2="21" y2="12" />
    <line x1="8" y1="18" x2="21" y2="18" />
    <line x1="3" y1="6" x2="3.01" y2="6" />
    <line x1="3" y1="12" x2="3.01" y2="12" />
    <line x1="3" y1="18" x2="3.01" y2="18" />
  </svg>
);

const GpsIcon = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <circle cx="12" cy="12" r="10" />
    <line x1="12" y1="2" x2="12" y2="22" />
    <line x1="2" y1="12" x2="22" y2="12" />
  </svg>
);

const ZapIcon = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
  </svg>
);

const MapPinIcon = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
    <circle cx="12" cy="10" r="3" />
  </svg>
);

const ClockIcon = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <circle cx="12" cy="12" r="10" />
    <polyline points="12 6 12 12 16 14" />
  </svg>
);

const BarChartIcon = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <line x1="18" y1="20" x2="18" y2="10" />
    <line x1="12" y1="20" x2="12" y2="4" />
    <line x1="6" y1="20" x2="6" y2="14" />
    <line x1="2" y1="20" x2="22" y2="20" />
  </svg>
);

const CheckIcon = () => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <polyline points="20 6 9 17 4 12" />
  </svg>
);

const ArrowIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <line x1="5" y1="12" x2="19" y2="12" />
    <polyline points="12 5 19 12 12 19" />
  </svg>
);

/* ── Data ───────────────────────────────────────────────────────────────── */
const solutions = [
  {
    icon: <TruckIcon />,
    title: "Fleet Management Systems",
    desc: "Real-time fleet monitoring with driver performance tracking, vehicle health diagnostics, maintenance scheduling, and fuel consumption analytics.",
  },
  {
    icon: <GpsIcon />,
    title: "Shipment Tracking Systems",
    desc: "Live GPS-based shipment visibility for customers and operations teams — with milestone alerts, ETA predictions, and exception management.",
  },
  {
    icon: <BoxIcon />,
    title: "Warehouse Management",
    desc: "Automated warehouse operations covering inbound receipts, bin allocation, pick-pack-ship workflows, and barcode/RFID integration.",
  },
  {
    icon: <RouteIcon />,
    title: "Route Optimization (AI-Based)",
    desc: "ML-powered routing engine that factors traffic, load capacity, delivery windows, and fuel cost to compute the most efficient daily routes.",
  },
  {
    icon: <InventoryIcon />,
    title: "Inventory Management Systems",
    desc: "Centralised inventory control with demand forecasting, reorder triggers, multi-warehouse stock visibility, and shrinkage tracking.",
  },
];

const projects = [
  {
    icon: <GpsIcon />,
    tag: "Tracking · GPS",
    title: "Real-Time Tracking System",
    desc: "Live shipment tracking platform for a mid-size courier network — with customer-facing ETA portal, operations dashboard, and automated SMS milestones.",
    features: [
      "Live GPS map with sub-second refresh",
      "Customer ETA & milestone notifications",
      "Exception detection & escalation flow",
    ],
  },
  {
    icon: <BoxIcon />,
    tag: "Warehouse · Operations",
    title: "Warehouse Management System",
    desc: "Full WMS for a 3PL operator — covering inbound GRN, intelligent bin allocation, pick-wave management, and barcode-driven dispatch workflows.",
    features: [
      "Barcode & RFID scan integration",
      "Bin allocation & pick wave engine",
      "Real-time inventory dashboard",
    ],
  },
  {
    icon: <RouteIcon />,
    tag: "AI · Routing",
    title: "AI Route Optimization Tool",
    desc: "An AI routing engine for a last-mile delivery company that reduced average delivery time by 28% and fuel costs by 22% within the first quarter.",
    features: [
      "Multi-stop route computation in <2s",
      "Real-time traffic & weather integration",
      "Driver mobile app with turn-by-turn nav",
    ],
  },
];

const benefits = [
  {
    icon: <ClockIcon />,
    stat: "28%",
    title: "Faster Deliveries",
    desc: "AI routing and real-time traffic adaptation cut average delivery times dramatically across last-mile and middle-mile operations.",
  },
  {
    icon: <BarChartIcon />,
    stat: "22%",
    title: "Reduced Operational Cost",
    desc: "Smart fuel management, optimised routing, and automated workflows reduce cost-per-delivery across fleet and warehouse operations.",
  },
  {
    icon: <MapPinIcon />,
    stat: "100%",
    title: "Real-Time Visibility",
    desc: "Live tracking for every shipment — customers, dispatchers, and operations teams all work from a single source of truth.",
  },
  {
    icon: <ZapIcon />,
    stat: "3×",
    title: "Improved Efficiency",
    desc: "Warehouse automation and intelligent scheduling multiply throughput without proportional increases in headcount or infrastructure.",
  },
];

/* ── Component ──────────────────────────────────────────────────────────── */
export default function Logistics() {
  return (
    <>
      <SEO
        title="Logistics AI: Supply Chain & Route Automation | Best Code Technology"
        description="Optimize logistics operations using AI-powered tracking and automation."
        keywords="logistics AI, supply chain automation"
        url="https://bestcodetechnology.in/industries/logistics"
      />

      <div className="ind-page ind-page--logistics">
        {/* ════════════════════════════════════════════════════════════════════
          HERO — dot-grid light bg, split: left content + right image placeholder
      ═══════════════════════════════════════════════════════════════════════ */}
        <section className="log-hero">
          <div className="container-xl">
            <div className="row align-items-center g-5">
              {/* Left: Content */}
              <div className="col-12 col-lg-6">
                <div className="log-hero__eyebrow">
                  <span className="log-pill">Logistics Industry</span>
                </div>

                <h1 className="log-hero__headline">
                  Optimize Supply Chain
                  <span> with Smart</span>
                  <br />
                  Technology
                </h1>

                <p className="log-hero__desc">
                  We develop logistics solutions that improve efficiency,
                  tracking, and real-time decision-making — for fleet operators,
                  3PLs, e-commerce brands, and supply chain enterprises.
                </p>

                <div className="log-hero__actions">
                  <a href="#solutions" className="log-btn-primary">
                    Explore Solutions
                    <ArrowIcon />
                  </a>
                  <a href="#projects" className="log-btn-ghost">
                    See What We Build
                  </a>
                </div>

                <div className="log-hero__stats">
                  <div className="log-stat">
                    <strong>AI-Powered</strong>
                    <span>Route Optimization</span>
                  </div>
                  <div className="log-stat-sep" aria-hidden="true" />
                  <div className="log-stat">
                    <strong>Real-Time</strong>
                    <span>GPS Tracking</span>
                  </div>
                  <div className="log-stat-sep" aria-hidden="true" />
                  <div className="log-stat">
                    <strong>99.9%</strong>
                    <span>Platform Uptime</span>
                  </div>
                </div>
              </div>

              {/* Right: live fleet dashboard */}
              <div className="col-12 col-lg-6">
                <div className="log-hero__visual">
                  <div className="log-dashboard">
                    <div className="log-dashboard__head">
                      <span className="log-dashboard__title">
                        <span className="log-dashboard__dot" aria-hidden="true" />
                        Fleet Control
                      </span>
                      <span className="log-dashboard__live">LIVE</span>
                    </div>

                    <div className="log-metrics">
                      <div className="log-metric">
                        <span className="log-metric__icon" aria-hidden="true">
                          <TruckIcon />
                        </span>
                        <span className="log-metric__value">Live</span>
                        <span className="log-metric__label">Fleet Tracking</span>
                      </div>
                      <div className="log-metric">
                        <span className="log-metric__icon" aria-hidden="true">
                          <RouteIcon />
                        </span>
                        <span className="log-metric__value">AI</span>
                        <span className="log-metric__label">Route Planning</span>
                      </div>
                      <div className="log-metric">
                        <span className="log-metric__icon" aria-hidden="true">
                          <InventoryIcon />
                        </span>
                        <span className="log-metric__value">Real-Time</span>
                        <span className="log-metric__label">Stock Sync</span>
                      </div>
                    </div>

                    <div className="log-route">
                      <div className="log-route__head">
                        <span className="log-route__label">
                          Active Route — Consignment Flow
                        </span>
                      </div>
                      <div className="log-route__track" aria-hidden="true">
                        <span className="log-route__line" />
                        <span className="log-route__progress" />
                        {["Origin", "Transit", "Hub", "Delivery"].map((s, i) => (
                          <span
                            key={s}
                            className={`log-route__stop log-route__stop--${i + 1}`}
                          >
                            <span className="log-route__pin">
                              <MapPinIcon />
                            </span>
                            <span className="log-route__stop-label">{s}</span>
                          </span>
                        ))}
                      </div>
                    </div>

                    <div className="log-feed">
                      <span className="log-feed__icon" aria-hidden="true">
                        <CheckIcon />
                      </span>
                      <span className="log-feed__body">
                        <span className="log-feed__title">
                          Consignment #4821 delivered
                        </span>
                        <span className="log-feed__meta">
                          Hub 3 · signed on delivery
                        </span>
                      </span>
                    </div>

                    <div className="log-feed">
                      <span className="log-feed__icon" aria-hidden="true">
                        <RouteIcon />
                      </span>
                      <span className="log-feed__body">
                        <span className="log-feed__title">
                          Route re-optimised — 3 vehicles
                        </span>
                        <span className="log-feed__meta">
                          Traffic delay · ETA recalculated
                        </span>
                      </span>
                    </div>

                    <div className="log-feed">
                      <span className="log-feed__icon" aria-hidden="true">
                        <BoxIcon />
                      </span>
                      <span className="log-feed__body">
                        <span className="log-feed__title">
                          Low stock flagged — Warehouse B
                        </span>
                        <span className="log-feed__meta">
                          Auto-reorder triggered
                        </span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* ════════════════════════════════════════════════════════════════════
          SOLUTIONS — bold numbered-badge cards (3+2 grid)
      ═══════════════════════════════════════════════════════════════════════ */}
        <section className="log-solutions" id="solutions">
          <div className="container-xl">
            <div className="row justify-content-center mb-4 mb-lg-5">
              <div className="col-12 col-md-10 col-lg-7 text-center">
                <span className="log-pill log-pill--subtle">Key Solutions</span>
                <h2 className="log-section-title mt-3">
                  Logistics Systems Built for Scale &amp; Speed
                </h2>
                <p className="log-section-sub">
                  Five core platform capabilities covering every layer of modern
                  supply chain operations — from fleet visibility to intelligent
                  routing.
                </p>
              </div>
            </div>

            <div className="row g-4">
              {solutions.map((item, i) => (
                <div
                  key={i}
                  className={`col-12 col-md-6 ${i < 3 ? "col-lg-4" : "col-lg-6"}`}
                >
                  <div className="log-sol-card">
                    <div className="log-sol-card__badge-zone">
                      <div className="log-sol-card__icon">{item.icon}</div>
                    </div>
                    <div className="log-sol-card__body">
                      <h4 className="log-sol-card__title">{item.title}</h4>
                      <p className="log-sol-card__desc">{item.desc}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ════════════════════════════════════════════════════════════════════
          TECHNOLOGIES — 2×2 dark tech grid
      ═══════════════════════════════════════════════════════════════════════ */}

        {/* ════════════════════════════════════════════════════════════════════
          PROJECTS — accent-header showcase cards (dark section)
      ═══════════════════════════════════════════════════════════════════════ */}
        <section className="log-projects" id="projects">
          <div className="container-xl">
            <div className="row justify-content-center mb-4 mb-lg-5">
              <div className="col-12 col-md-10 col-lg-7 text-center">
                <span className="log-pill log-pill--dark">Platform Capabilities</span>
                <h2 className="log-section-title log-section-title--light mt-3">
                  What We Build for Logistics
                </h2>
                <p className="log-section-sub log-section-sub--light">
                  Three platform builds we take on for supply chain teams —
                  spanning tracking, warehouse operations, and AI routing.
                </p>
              </div>
            </div>

            <div className="row g-4">
              {projects.map((project, i) => (
                <div key={i} className="col-12 col-lg-4">
                  <div className="log-project-card">
                    {/* Colored accent header */}
                    <div
                      className={`log-project-card__header log-project-card__header--${i + 1}`}
                    >
                      <div className="log-project-card__header-icon">
                        {project.icon}
                      </div>
                    </div>
                    <div className="log-project-card__body">
                      <span className="log-project-card__tag">
                        {project.tag}
                      </span>
                      <h3 className="log-project-card__title">
                        {project.title}
                      </h3>
                      <p className="log-project-card__desc">{project.desc}</p>
                      <ul className="log-project-card__features">
                        {project.features.map((feat, fi) => (
                          <li key={fi}>
                            <CheckIcon />
                            <span>{feat}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ════════════════════════════════════════════════════════════════════
          BENEFITS — horizontal 4-stat cards + bottom CTA strip
      ═══════════════════════════════════════════════════════════════════════ */}
        <section className="log-benefits">
          <div className="container-xl">
            <div className="row justify-content-center mb-4 mb-lg-5">
              <div className="col-12 col-md-10 col-lg-7 text-center">
                <span className="log-pill log-pill--subtle">Why BCT</span>
                <h2 className="log-section-title mt-3">
                  The Advantage of Building with BCT
                </h2>
                <p className="log-section-sub">
                  From AI-powered route engines to real-time fleet visibility,
                  every logistics platform we build is designed for measurable
                  operational outcomes — not just features.
                </p>
              </div>
            </div>

            <div className="row g-4">
              {benefits.map((b, i) => (
                <div key={i} className="col-12 col-sm-6 col-xl-3">
                  <div className="log-benefit-card">
                    <div className="log-benefit-card__icon">{b.icon}</div>
                    <div className="log-benefit-card__stat">{b.stat}</div>
                    <h4 className="log-benefit-card__title">{b.title}</h4>
                    <p className="log-benefit-card__desc">{b.desc}</p>
                  </div>
                </div>
              ))}
            </div>

            {/* CTA strip */}
            <div className="log-cta-strip">
              <div className="row align-items-center">
                <div className="col-12 col-lg-8">
                  <h3 className="log-cta-strip__title">
                    Ready to modernise your logistics operations?
                  </h3>
                  <p className="log-cta-strip__sub">
                    Let's build smarter supply chain technology together.
                  </p>
                </div>
                <div className="col-12 col-lg-4 text-lg-end">
                  <a
                    href="/services/ai-applications"
                    className="log-btn-primary"
                  >
                    Start a Project
                    <ArrowIcon />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
